import { useEffect, useRef, useState } from "react";
import { ChartModifierBase2D, CursorModifier, DateLabelProvider, DateTimeNumericAxis, EAxisType, EChart2DModifierType, EExecuteOn, ESeriesType, EThemeProviderType, FastColumnRenderableSeries, FastImpulseRenderableSeries, FastLineRenderableSeries, HorizontalLineAnnotation, MouseWheelZoomModifier, NumberRange, NumericAxis, RolloverModifier, RolloverModifierRenderableSeriesProps, RubberBandXyZoomModifier, SciChartJsNavyTheme, SciChartSurface, SplineMountainRenderableSeries, XyDataSeries, ZoomExtentsModifier, ZoomPanModifier } from "scichart";
import { SciChartReact } from "scichart-react";
import { CustomDateTimeLabelProvider } from "./CustomDateTimeLabelProvider ";
import { Mouse } from "@material-ui/icons";
import { ClickModifier } from "./ClickModifier";
import { exec } from "apexcharts";
import { CustomZoomWheelModifier } from "./ZoomWheelModifier";
import { CustomZoomDragModifier } from "./ZoomDragModifier";
import { CustomRubberBandXyZoomModifier } from "./CustomRubberBandXyZoomModifier";
import { stroke } from "pdf-lib";

SciChartSurface.loadWasmFromCDN();
SciChartSurface.setRuntimeLicenseKey("b+78WIUev1SljKl2QNPBUchZuKnw2JZsvv7QSxDLgfrEcXd1fPKqOSoCurGHixz+KysQSbO9MfcpU+VhjPrWmJmrD8MULoeeq1ez2tTx51bB7idEYhxRXmHBk7h+oA56FtieS2AgqkcKPvN89XTQleAaxmt8QgN1uzBYDy52SxX8tnz3BczEmV4fd9gijMPynpm8TEFK3jOSgliqW1sRsmTLZpKeOVbpFoC3YQvLEoBgq4HnHxTGqVNgryWgyKsDwtqMZyd00UQxEvXzEqVdwNblXEhXdX09ruixCXZcNZhHQkWdh2IwIBlevFHim+5KMrfxDbeLtf0ulMC6J9q+Rub7X8+AosgQDILxHlNn+Q+zmRidNMy9EwkA0KUOF3gLUezTMvEDr20nYoBx99J4JALAspoY8lMhppAWbwU1iCqQiOSk3fbuRFc3VjlXy+l0ewp31dkKMTGIV4r777UX1iOftU8cgBEimgW1/OEZQT8Hq941zx6ATTqgia+BZVGbFIKOBz1sh+TxNfbmNJzFK2Nnr/+8jw88p52E5xNixgiRU7YhVWqWDUU414uP1wzj+tSIqTuHXuG4j6oSI8eSUDU8tLzZwZ/IYeQ5UhlWBhfL8ZJnzH2YL1xGlft9uAQZ2d8SbBSQRgfmvX31oF3yWebEqD6gaOGUUmNsYNsSddYlfUysSjjSn1D+2cf8qbUacxLVRSBsxZOxoIZwCydm1IV3A0gRt9CsVbpuOwGUQYo9fjIgnRHhSRV0iBekMAT+S4IchElmo6YzsYPB6lEwEFQn9W9n3Vs4QDc7lCA=");

// SciChartSurface.UseCommunityLicense()

const SciChart = ({ yposition, x, y, threshHoldValue, xAxisMax, xAxisMin, color, signalName, type, thick, grid, yAxisMax, yAxisMin, thresholdtLine, thresholdtcolor, thresholdthick, showThresholdLine, signalLinetype, textAnnotations, showAnnotation, hoverMode, invertY, xAxisA, yAxisA, rawSignalsAConfig, altSignal, signalLabel, setCommentModal, setCurrentPoint, setXaxisMax, setXaxisMin, play, hideThreshold, xAxisChanged, setXAxisChanged, reportComment, commentId, postupdateComment, commentUpdated, postdeleteComment, commentDeleted, index, setGlobalConfig, globalConfig, linkGraphs, group, linkingType, session, setGlobalconfigchanges, globalconfigchanges, setSessionSignal, setReportComment, rawSignalsAName, zoomEnabled, setCommentDeleted, setTextAnnotations, units }) => {

  const sciChartSurfaceRef = useRef(null);
  const dataSeriesRef = useRef(null);

  const [wasmContext, setWasmContext] = useState(null);


  const key = "b+78WIUev1SljKl2QNPBUchZuKnw2JZsvv7QSxDLgfrEcXd1fPKqOSoCurGHixz+KysQSbO9MfcpU+VhjPrWmJmrD8MULoeeq1ez2tTx51bB7idEYhxRXmHBk7h+oA56FtieS2AgqkcKPvN89XTQleAaxmt8QgN1uzBYDy52SxX8tnz3BczEmV4fd9gijMPynpm8TEFK3jOSgliqW1sRsmTLZpKeOVbpFoC3YQvLEoBgq4HnHxTGqVNgryWgyKsDwtqMZyd00UQxEvXzEqVdwNblXEhXdX09ruixCXZcNZhHQkWdh2IwIBlevFHim+5KMrfxDbeLtf0ulMC6J9q+Rub7X8+AosgQDILxHlNn+Q+zmRidNMy9EwkA0KUOF3gLUezTMvEDr20nYoBx99J4JALAspoY8lMhppAWbwU1iCqQiOSk3fbuRFc3VjlXy+l0ewp31dkKMTGIV4r777UX1iOftU8cgBEimgW1/OEZQT8Hq941zx6ATTqgia+BZVGbFIKOBz1sh+TxNfbmNJzFK2Nnr/+8jw88p52E5xNixgiRU7YhVWqWDUU414uP1wzj+tSIqTuHXuG4j6oSI8eSUDU8tLzZwZ/IYeQ5UhlWBhfL8ZJnzH2YL1xGlft9uAQZ2d8SbBSQRgfmvX31oF3yWebEqD6gaOGUUmNsYNsSddYlfUysSjjSn1D+2cf8qbUacxLVRSBsxZOxoIZwCydm1IV3A0gRt9CsVbpuOwGUQYo9fjIgnRHhSRV0iBekMAT+S4IchElmo6YzsYPB6lEwEFQn9W9n3Vs4QDc7lCA="

  useEffect(() => {
    const initSciChart = async () => {
      //   SciChartSurface.setRuntimeLicenseKey("YOUR_LICENSE_KEY");
      console.log("threshHoldValue", thresholdtLine, thresholdtcolor, thresholdthick)
      // ✅ Create SciChartSurface
      const { sciChartSurface, wasmContext } = await SciChartSurface.create(`${signalName}_${index}_scichart-root`);
      setWasmContext(wasmContext)
      // sciChartSurface.setRuntimeLicenseKey(key)
      // ✅ Apply theme and manually set background
      
      sciChartSurface.applyTheme(new SciChartJsNavyTheme());
      sciChartSurface.background = "white"; // 🎨 Change background color

      // ✅ Add X & Y Axes

      sciChartSurface.xAxes.add(new NumericAxis(wasmContext, {
        labelProvider: new CustomDateTimeLabelProvider(), // 🕒 Format X-Axis as HH:mm:ss
        drawMajorGridLines: true, // 🚫 Hide major grid lines
        drawMinorGridLines: false, // 🚫 Hide minor grid lines
        drawBands: false, // 🚫 Hide background bands
        labelStyle: { fontSize: 12, color: "black", fontWeight: 700 }, // 🎨 Customize X-Axis labels
        visibleRangeLimit: new NumberRange(x[0], x[x.length - 1]), // 📏 Limit the visible range of the X-Axis
        // visibleRange:  new NumberRange(x[0], x[x.length - 1]),
        id: "xaxis1",
        majorGridLineStyle: { color: "rgba(0,0,0,0.1)", strokeThickness: 1 }, // 🎨 Customize minor grid lines
      }));


      console.log("yposition", yposition)
      sciChartSurface.yAxes.add(new NumericAxis(wasmContext, {
        axisAlignment: yposition == 1 ? "Left" : "Right", // 🎯 Align Y axis to left
        drawMajorGridLines: true, // 🚫 Hide major grid lines
        drawMinorGridLines: false, // 🚫 Hide minor grid lines
        drawBands: false, // 🚫 Hide background bands

        labelStyle: { fontSize: 12, color: "black", fontWeight: 700 }, // 🎨 Customize X-Axis labels
        id: "yaxis1",

        axisTitleStyle: { fontSize: 12, color: "black", fontWeight: 700 },
        flippedCoordinates: invertY == 1, // 🔄 Flip the Y-Axis to the right
        majorGridLineStyle: { color: "rgba(0,0,0,0.1)", strokeThickness: 1 }, // 🎨 Customize minor grid lines
      }));
      console.log("rawSignalsAName", rawSignalsAName)
      sciChartSurface.yAxes.add(new NumericAxis(wasmContext, {
        axisAlignment: yposition == 1 ? "Right" : "Left", // 🎯 Align Y axis to left
        drawMajorGridLines: true, // 🚫 Hide major grid lines
        drawMinorGridLines: false, // 🚫 Hide minor grid lines
        drawBands: false, // 🚫 Hide background bands

        labelStyle: { fontSize: 12, color: "black", fontWeight: 700 }, // 🎨 Customize X-Axis labels
        isVisible: altSignal ? true : false,
        id: "yaxis2",
        visibleRange: yAxisA.length > 0 ? new NumberRange(rawSignalsAConfig.ymin = "" ? Math.floor(Math.min(...yAxisA)) : rawSignalsAConfig.ymin, rawSignalsAConfig.ymax = "" ? Math.ceil(Math.max(...yAxisA)) : rawSignalsAConfig.ymax) : new NumberRange(0, Math.max(...yAxisA)),
        axisTitle: rawSignalsAName,
        axisTitleStyle: { fontSize: 12, color: "black", fontWeight: 700 },
        flippedCoordinates: invertY == 1, // 🔄 Flip the Y-Axis to the right
        majorGridLineStyle: { color: "rgba(0,0,0,0.1)", strokeThickness: 1 }, // 🎨 Customize minor grid lines
      }));



      const dataSeries = new XyDataSeries(wasmContext, {
        xValues: x,
        yValues: y
      });

      const alternateSeries = xAxisA.length > 0 ?       
      new XyDataSeries(wasmContext, {
        xValues: xAxisA,
        yValues: yAxisA
      })
      :
      new XyDataSeries(wasmContext, {
        xValues: [],
        yValues: []
      });



      sciChartSurface.renderableSeries.add(
        new FastLineRenderableSeries(wasmContext, {
          dataSeries,

          fill: color.hex ? color.hex : color,
          stroke: color.hex ? color.hex : color,
          strokeDashArray: signalLinetype == "solid" ? [] : thresholdtLine == "dot" ? [1, 1] : [5, 1],
          strokeThickness: thick,
          isVisible: type == "line" ? true : false,
          id: "signal",
          xAxisId: "xaxis1",
          yAxisId: "yaxis1"

        }))



      sciChartSurface.renderableSeries.add(
        new FastColumnRenderableSeries(wasmContext, {
          dataSeries,
          tooltipTitle: signalName,

          fill: color.hex ? color.hex : color,
          stroke: color.hex ? color.hex : color,
          strokeDashArray: signalLinetype == "solid" ? [] : thresholdtLine == "dot" ? [1, 1] : [5, 1],
          isVisible: type == "line" ? false : true,
          strokeThickness: thick,
          id: "signalbar",
          xAxisId: "xaxis1",
          yAxisId: "yaxis1"

        })
      )

      sciChartSurface.renderableSeries.get(0).rolloverModifierProps.tooltipTitle = signalLabel ? signalLabel : signalName;
      sciChartSurface.renderableSeries.get(1).rolloverModifierProps.tooltipTitle = signalLabel ? signalLabel : signalName;



      console.log("rawSignalsAConfig", rawSignalsAConfig)
      if (xAxisA.length > 0 && yAxisA.length > 0 && yAxisA.length == xAxisA.length) {

        sciChartSurface.renderableSeries.add(
          new FastLineRenderableSeries(wasmContext, {
            dataSeries: alternateSeries,
            fill: rawSignalsAConfig.color.hex ? rawSignalsAConfig.color.hex : rawSignalsAConfig.color,
            stroke: rawSignalsAConfig.color.hex ? rawSignalsAConfig.color.hex : rawSignalsAConfig.color,
            strokeDashArray: [],
            isVisible: altSignal ? true : false,
            tooltipTitle: rawSignalsAName,
            strokeThickness: thick,
            id: "asignalbar",
            xAxisId: "xaxis1",
            yAxisId: "yaxis2"

          })
        )

        sciChartSurface.renderableSeries.get(2).rolloverModifierProps.tooltipTitle = rawSignalsAName

      }



      // }
      console.log("xaxisrange", xAxisMin, xAxisMax)
      if (xAxisMin == "0") {
        setXaxisMin(x[0])
      }
      if (xAxisMax == "full") {
        setXaxisMax(x[x.length - 1])
      }
      sciChartSurface.xAxes.get(0).visibleRange = new NumberRange(xAxisMin == "0" ? x[0] : xAxisMin, xAxisMax == "full" ? x[x.length - 1] : xAxisMax);
      sciChartSurface.yAxes.get(0).visibleRange = new NumberRange(yAxisMin, yAxisMax);
      sciChartSurface.xAxes.get(0).drawMajorGridLines = grid == 1 || grid == 4 ? true : false;
      sciChartSurface.yAxes.get(0).drawMajorGridLines = grid == 1 || grid == 3 ? true : false;
      console.log("textAnnotations", textAnnotations, hideThreshold)
      textAnnotations.push(new HorizontalLineAnnotation({
        id: 'threshhold',
        yAxisId: "yaxis1",
        y1: threshHoldValue,
        isHidden: !hideThreshold,
        strokeThickness: thresholdthick,
        stroke: thresholdtcolor.hex ? thresholdtcolor.hex : thresholdtcolor,
        strokeDashArray: thresholdtLine == "solid" ? [] : thresholdtLine == "dot" ? [1, 1] : [5, 1],
      }))
      // sciChartSurface.annotations.add(textAnnotations);
      // sciChartSurface.annotations.add()
      textAnnotations.forEach((annotation) => {
        const found = sciChartSurface.annotations.asArray().find(a => a.id === annotation.id);
        console.log("found", found, annotation.id, sciChartSurface.annotations.items)
        if(!found){
      
          sciChartSurface.annotations.add(annotation);            
        }
      });
      sciChartSurface.chartModifiers.add(
        new CustomZoomDragModifier((args) => {
          console.log("Mouse wheel used!", sciChartSurface.xAxes.get(0).visibleRange);
          setXaxisMax(Number(sciChartSurface.xAxes.get(0).visibleRange.max));
          setXaxisMin(Number(sciChartSurface.xAxes.get(0).visibleRange.min));
          setGlobalConfig(prevState => ({
            ...prevState,
            xmax: Number(sciChartSurface.xAxes.get(0).visibleRange.max),
            xmin: Number(sciChartSurface.xAxes.get(0).visibleRange.min)

          }))
          setSessionSignal()

        }, { xyDirection: "XDirection" }),
        // new ZoomExtentsModifier(),
        new CustomZoomWheelModifier((args) => {
          console.log("Mouse wheel used!", sciChartSurface.xAxes.get(0).visibleRange);
          setXaxisMax(Number(sciChartSurface.xAxes.get(0).visibleRange.max));
          setXaxisMin(Number(sciChartSurface.xAxes.get(0).visibleRange.min));
          setGlobalConfig(prevState => ({
            ...prevState,
            xmax: Number(sciChartSurface.xAxes.get(0).visibleRange.max),
            xmin: Number(sciChartSurface.xAxes.get(0).visibleRange.min)

          }))
          setSessionSignal()
        }, { xyDirection: "XDirection", id: "zoomWheel", isEnabled: zoomEnabled }),
        new CustomRubberBandXyZoomModifier((start) => {
          console.log("Mouse wheel used! rubber", sciChartSurface.xAxes.get(0).visibleRange);
          setXaxisMax(Number(sciChartSurface.xAxes.get(0).visibleRange.max));
          setXaxisMin(Number(sciChartSurface.xAxes.get(0).visibleRange.min));
          setGlobalConfig(prevState => ({
            ...prevState,
            xmax: Number(sciChartSurface.xAxes.get(0).visibleRange.max),
            xmin: Number(sciChartSurface.xAxes.get(0).visibleRange.min)

          }))
          setSessionSignal()

        }, { xyDirection: "XDirection", executeOn: EExecuteOn.MouseRightButton, fill: "#80008020", stroke: "purple" }),
        new ClickModifier({ id: "clicked", isEnabled: hoverMode, cb: handleClick }),
      );


      dataSeriesRef.current = dataSeries;

      sciChartSurfaceRef.current = sciChartSurface;
    };

    if (signalName) {
      initSciChart();

    }


    return () => {
      sciChartSurfaceRef.current?.delete();
    };
  }, [signalName]);

  const handleClick = (args) => {
    passdata(args)
  }

  const passdata = (args) => {
    console.log("args", args, hoverMode)
    setCommentDeleted(false)
    setCommentModal(true);
    setCurrentPoint(args)
    setReportComment("")
  }



  const getTooltipDataTemplate = (seriesInfo, tooltipTitle, tooltipLabelX, tooltipLabelY) => {
    console.log("seriesInfo", seriesInfo, tooltipTitle, tooltipLabelX, tooltipLabelY)

    if (seriesInfo === undefined) return;
    const daylight = new Date(0).getTimezoneOffset() * 60 * 1000
    const sereis = seriesInfo.length > 1 ? seriesInfo[1] : seriesInfo[0];
    const date = new Date(seriesInfo.xValue);
    const x_value = date.toTimeString().split(' ')[0];
    const lines = [];

    lines.push(`Time: ${x_value}`)
    lines.push(`${tooltipTitle} : ${parseFloat(seriesInfo.yValue).toFixed(2)}`)

    // lines.push(`);
    return lines;
  };




  useEffect(() => {
    if (sciChartSurfaceRef.current) {

      const sciChartSurface = sciChartSurfaceRef.current;


      const signalSeries = new XyDataSeries(wasmContext, {
        xValues: x,
        yValues: y
      });



      if (yAxisA.length == xAxisA.length && altSignal) {

        const alternateSeries = new XyDataSeries(wasmContext, {
          xValues: xAxisA,
          yValues: yAxisA
        });

        if (sciChartSurface.renderableSeries.get(2)) {

          sciChartSurface.renderableSeries.get(2).stroke = rawSignalsAConfig.color.hex ? rawSignalsAConfig.color.hex : rawSignalsAConfig.color;

          sciChartSurface.renderableSeries.get(2).fill = rawSignalsAConfig.color.hex ? rawSignalsAConfig.color.hex : rawSignalsAConfig.color,
            sciChartSurface.renderableSeries.get(2).dataSeries = alternateSeries;
          sciChartSurface.renderableSeries.get(2).isVisible = altSignal || altSignal != "" ? true : false;

        }
        else {

          sciChartSurface.renderableSeries.add(
            new FastLineRenderableSeries(wasmContext, {
              dataSeries: alternateSeries,
              visibleRange: new NumberRange(0, Math.max(...yAxisA)),
              fill: rawSignalsAConfig.color.hex ? rawSignalsAConfig.color.hex : rawSignalsAConfig.color,
              stroke: rawSignalsAConfig.color.hex ? rawSignalsAConfig.color.hex : rawSignalsAConfig.color,
              strokeDashArray: [],
              tooltipTitle: rawSignalsAName,
              // isVisible: altSignal ? true : false,
              strokeThickness: thick,
              id: "asignalbar",
              xAxisId: "xaxis1",
              yAxisId: "yaxis2"

            })
          )

        }
      }

      if (sciChartSurface.renderableSeries.get(2)) {
        sciChartSurface.renderableSeries.get(2).isVisible = altSignal && altSignal != "" ? true : false;

      }



      sciChartSurface.renderableSeries.get(0).stroke = color.hex ? color.hex : color;
      sciChartSurface.renderableSeries.get(0).strokeThickness = thick;
      sciChartSurface.renderableSeries.get(0).strokeDashArray = signalLinetype == "solid" ? [] : signalLinetype == "dot" ? [1, 1] : [5, 1];
      sciChartSurface.renderableSeries.get(0).isVisible = type == "line" ? true : false,
        sciChartSurface.renderableSeries.get(0).dataSeries = signalSeries;


      sciChartSurface.renderableSeries.get(1).fill = type == "obar" ? "#fff" : color.hex ? color.hex : color;
      sciChartSurface.renderableSeries.get(1).stroke = color.hex ? color.hex : color;
      sciChartSurface.renderableSeries.get(1).strokeDashArray = thick;
      sciChartSurface.renderableSeries.get(1).strokeDashArray = signalLinetype == "solid" ? [] : signalLinetype == "dot" ? [1, 1] : [5, 1];
      sciChartSurface.renderableSeries.get(1).isVisible = type == "line" ? false : true;

      setTimeout(() => {
        sciChartSurface.renderableSeries.get(1).dataSeries = signalSeries;        

      }, 500);

      console.log("handleUnitChange",sciChartSurface.renderableSeries.get(0).dataSeries , sciChartSurface.renderableSeries.get(1).dataSeries)

      if (sciChartSurface.renderableSeries.get(2)) {
        sciChartSurface.renderableSeries.get(2).rolloverModifierProps.tooltipTitle = rawSignalsAName
      }
      sciChartSurface.yAxes.get(0).visibleRange = new NumberRange(yAxisMin, yAxisMax);

      if (!globalconfigchanges) {
        sciChartSurface.xAxes.get(0).visibleRange = new NumberRange(xAxisMin == "0" ? x[0] : xAxisMin, xAxisMax == "full" ? x[x.length - 1] : xAxisMax);

      }



      if (altSignal && altSignal != "" && yAxisA.length > 0 && xAxisA.length > 0) {
        sciChartSurface.yAxes.get(1).visibleRange = new NumberRange(rawSignalsAConfig.ymin = "" ? Math.floor(Math.min(...yAxisA)) : rawSignalsAConfig.ymin, rawSignalsAConfig.ymax = "" ? Math.ceil(Math.max(...yAxisA)) : rawSignalsAConfig.ymax);
      }
      sciChartSurface.yAxes.get(1).axisTitle = rawSignalsAName
      sciChartSurface.yAxes.get(1).isVisible = altSignal ? true : false;

      sciChartSurface.yAxes.get(0).axisAlignment = yposition == "1" ? "Left" : "Right";

      sciChartSurface.xAxes.get(0).drawMajorGridLines = grid == 1 || grid == 4 ? true : false;
      sciChartSurface.yAxes.get(0).drawMajorGridLines = grid == 1 || grid == 3 ? true : false;
      sciChartSurface.yAxes.get(0).flippedCoordinates = invertY == "1" ? true : false;
      sciChartSurface.yAxes.get(1).flippedCoordinates = invertY == "1" ? true : false;
      sciChartSurface.yAxes.get(1).axisAlignment = yposition == "1" ? "Right" : "Left";
      sciChartSurface.yAxes.get(1).isVisible = altSignal ? true : false;

      console.log("showAnnotation", showAnnotation, commentDeleted, signalLabel, sciChartSurface.annotations)


      if (showAnnotation == 1) {
        sciChartSurface.annotations.items.forEach((annotation) => {
          if (annotation.id != "threshhold") {
            annotation.isHidden = false;
          }
        })
        if (!commentDeleted && !commentUpdated) {
          console.log("textAnnotations", textAnnotations, sciChartSurface.annotations.items)
          // sciChartSurface.annotations.add(textAnnotations[textAnnotations.length - 1]);
          // sciChartSurface.annotations.remove();
          // sciChartSurface.annotations.add(textAnnotations)

          // Step 1: Clear previous annotations
          // sciChartSurface.annotations.asArray().forEach((annotation) => {
          //   if (annotation) {
          //     sciChartSurface.annotations.remove(annotation);
          //     annotation.delete?.(); // safe call
          //   }
          // });

          // Step 2: Add current text annotations
          textAnnotations.forEach((annotation) => {
            const found = sciChartSurface.annotations.asArray().find(a => a.id === annotation.id);
            console.log("found", found, annotation.id, sciChartSurface.annotations.items)
            if(!found){
          
              sciChartSurface.annotations.add(annotation);            
            }
          });

        } else {
          if (commentUpdated) {




            sciChartSurface.annotations.items.forEach((annotation) => {
              if (annotation.id == commentId) {
                annotation.text = reportComment;
                postupdateComment()
              }
            })

          }
          if (commentDeleted) {
            setCommentDeleted(false)
            postdeleteComment()
            // console.log("textAnnotations", textAnnotations, sciChartSurface.annotations.items)
            // sciChartSurface.annotations.items = sciChartSurface.annotations.items.filter(item => item.id !== commentId);
            let _oldAnnotation = textAnnotations;
            // console.log("textAnnotations", textAnnotations, sciChartSurface.annotations.items)
            _oldAnnotation = _oldAnnotation.filter(item => item.id !== commentId);

            // sciChartSurface.annotations.clear();

            const toRemove = sciChartSurface.annotations.asArray().find(a => a.id === commentId);
            if (toRemove) {
              sciChartSurface.annotations.remove(toRemove);
            }

            setTextAnnotations(_oldAnnotation)
            // console.log("textAnnotations", textAnnotations, _oldAnnotation)



            // sciChartSurface.annotations.items.forEach((annotation) => {
            //   console.log("annotation", annotation.id, commentId)
            //   if (annotation.id == commentId) {
            //     annotation.text = "";
            //     annotation.isVisible = false;
            //     let _oldAnnotation  = textAnnotations ;

            //     _oldAnnotation.forEach((textAnnotation) => {
            //       if (textAnnotation.id == commentId) {
            //         textAnnotation.text = "";
            //         textAnnotation.isVisible = false;
            //       }
            //     })
            //     setTextAnnotations(_oldAnnotation)

            //   }
            // })

          }

        }

      }
      else {
        sciChartSurface.annotations.items.forEach((annotation) => {
          if (annotation.id != "threshhold") {
            annotation.isHidden = true;
          }
        })

      }


      sciChartSurface.annotations.items.forEach((annotation) => {
        if (annotation.id == "threshhold") {
          annotation.isHidden = !hideThreshold;
          annotation.strokeThickness = thresholdthick;
          annotation.stroke = thresholdtcolor.hex ? thresholdtcolor.hex : thresholdtcolor;
          annotation.y1 = threshHoldValue;
          annotation.strokeDashArray = thresholdtLine == "solid" ? [] : thresholdtLine == "dot" ? [1, 1] : [5, 1];
        }
      })


      sciChartSurface.chartModifiers.getById("clicked").isEnabled = hoverMode;
      const zoomWheelmodifier = sciChartSurface.chartModifiers.getById("zoomWheel")
      zoomWheelmodifier.isEnabled = zoomEnabled
      const modifier = sciChartSurface.chartModifiers.getById("hover")
      console.log("hoverMode", modifier)
      if (hoverMode) {
        sciChartSurface.chartModifiers.add(new RolloverModifier({
          id: "hover",
          showAxisLabel: false,
          rolloverLineStrokeDashArray: [5, 2],
          showTooltip: true,
          rolloverLineStroke: color.hex ? color.hex : color,
          showRolloverLine: true,
          isEnabled: true,
          tooltipDataTemplate: getTooltipDataTemplate,
        }))
      }
      else {
        if (modifier !== undefined) {
          sciChartSurface.chartModifiers.remove(modifier)
        }
      }
    
      
    }

   

  }, [yposition, color, xAxisChanged, thick, type, x, y, grid, yAxisMin, yAxisMax, threshHoldValue, thresholdtLine, thresholdtcolor, thresholdthick, showThresholdLine, signalLinetype, textAnnotations, showAnnotation, invertY, xAxisA, yAxisA, altSignal, hoverMode, play,units, hideThreshold, commentUpdated, commentDeleted, zoomEnabled])

  return (
    <>
      <div id={`${signalName}_${index}_scichart-root`} style={{ width: "100%", height: "100%" }} />
    </>

  )

}


export default SciChart;

